import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  addDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import getUserGroup from "../../shared/components/getUserGroup.js";

const CreatePatient = () => {
  const [group, setGroup] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    document: "",
    email: "",
    phone: "",
    gender: "",
    country: "",
    city: "",
    birthdate: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const userGroup = await getUserGroup();
        setGroup(userGroup);
      } catch (error) {
        setError("No se pudo obtener el grupo del usuario.");
      }
    };
    fetchGroup();
  }, []);

  const validateForm = () => {
    const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
    const documentRegex = /^\d{6,10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+]+$/;

    if (!formData.name.match(nameRegex))
      return "El nombre solo puede contener letras y espacios.";
    if (!formData.surname.match(nameRegex))
      return "El apellido solo puede contener letras y espacios.";
    if (!formData.document.match(documentRegex))
      return "El documento debe tener entre 6 y 10 dígitos numéricos.";
    if (!formData.email.match(emailRegex))
      return "El correo electrónico no es válido.";
    if (!formData.phone.match(phoneRegex))
      return "El teléfono solo puede contener números y el símbolo '+'.";
    if (!["Masculino", "Femenino", "Otro"].includes(formData.gender))
      return "Selecciona una opción válida.";
    if (!formData.country.match(nameRegex))
      return "El país solo puede contener letras y espacios.";
    if (!formData.city.match(nameRegex))
      return "La ciudad solo puede contener letras y espacios.";
    if (!formData.birthdate) return "La fecha de nacimiento es obligatoria.";

    return null;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setSuccess("");
      setError(validationError);
      return;
    }

    try {
      const db = getFirestore();
      const patientsCollection = collection(db, "registeredPatients");

      const q = query(
        patientsCollection,
        where("document", "==", formData.document),
        where("group", "==", group)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setError("Ya existe un paciente con este documento en este grupo.");
        return;
      }

      await addDoc(patientsCollection, {
        ...formData,
        group,
      });

      setSuccess("El registro del paciente se guardó correctamente.");
      setError("");
      setFormData({
        name: "",
        surname: "",
        document: "",
        email: "",
        phone: "",
        gender: "",
        country: "",
        city: "",
        birthdate: "",
      });
    } catch (error) {
      setError("No se pudo guardar el registro. Inténtalo nuevamente.");
      setSuccess("");
    }
  };

  return (
    <div>
      <h2>Crear Paciente</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Nombre"
            className="generalFormInput"
          />
        </div>
        <div>
          <input
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleInputChange}
            placeholder="Apellido"
            className="generalFormInput"
          />
        </div>
        <div>
          <input
            type="text"
            name="document"
            value={formData.document}
            onChange={handleInputChange}
            placeholder="Documento de identidad"
            className="generalFormInput"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Correo electrónico"
            className="generalFormInput"
          />
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="Teléfono"
            className="generalFormInput"
          />
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className="generalFormInput"
          >
            <option value="">-- Género --</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
            <option value="Otro">Otro</option>
          </select>
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleInputChange}
            placeholder="País"
            className="generalFormInput"
          />
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
            placeholder="Ciudad"
            className="generalFormInput"
          />
          <input
            type="date"
            name="birthdate"
            value={formData.birthdate}
            onChange={handleInputChange}
            placeholder="Fecha de nacimiento"
            className="generalFormInput"
          />
        </div>
        <button type="submit">Guardar</button>
      </form>
    </div>
  );
};

export default CreatePatient;
